import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter } from "react-router-dom";
import filterFactory from "react-bootstrap-table2-filter";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Input,
  Label,
  Badge,
} from "reactstrap";
import moment from "moment";

import Breadcrumbs from "components/Common/Breadcrumb";
// import { getParticipantPayments } from "store/participantPayments/actions";
import { getParticipantPayment, confirmpayment } from "store/Payment/actions";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { isEmpty } from "lodash";
import "assets/scss/table.scss";

class PaymentStatement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      paidamountFilter: "",
      dateToActive: false,
      filterVerification: "All",
      filterPaymentStatus: "All",
      currentPage: 1,
      rowsPerPage: 50,
      dateFrom: "",
      dateTo: new Date().toISOString().split("T")[0], // Show current date
      dateToActive: false,
      paydateFilter: "",
      transactionDateFilter: "",
      nameFilter: "",
      amountFilter: "",
      methodFilter: "",
      statusFilter: "",
      verificationFilter: "",
    };
  }

  componentDidMount() {
    const routeId = this.props.match?.params?.id;

    console.log("Component Mounted");
    console.log("Route ID:", routeId);

    if (routeId) {
      console.log("Fetching payments for participant:", routeId);
      this.props.onGetParticipantPayments({ participant_id: routeId });
    } else {
      console.log("Fetching all payments");
      this.props.onGetParticipantPayments();
    }
  }
  getFilteredPayments() {
    const {
      paydateFilter,
      transactionDateFilter,
      nameFilter,
      amountFilter,
      methodFilter,
      statusFilter,
      verificationFilter,
      paidamountFilter,
      searchText,
      filterVerification,
      filterPaymentStatus,
      dateFrom,
      dateTo,
      dateToActive,
    } = this.state;

    const { GetPayment } = this.props;

    if (!GetPayment || !Array.isArray(GetPayment)) return [];

    return GetPayment.filter(p => {
      // ✅ Participant Dropdown
      if (searchText && p.participant_name !== searchText) return false;

      // ✅ Verification Dropdown
      if (
        filterVerification !== "All" &&
        p.payment_reconcile_status !== filterVerification
      )
        return false;

      // ✅ Payment Status Dropdown
      if (
        filterPaymentStatus !== "All" &&
        p.payment_status !== filterPaymentStatus
      )
        return false;

      // ✅ Date Filters
      if (dateFrom && new Date(p.paydate) < new Date(dateFrom)) return false;

      if (dateToActive && new Date(p.paydate) > new Date(dateTo)) return false;

      // ================= COLUMN FILTERS =================

      if (
        nameFilter &&
        !p.participant_name?.toLowerCase().includes(nameFilter.toLowerCase())
      )
        return false;

      if (amountFilter && !String(p.price || "").includes(amountFilter))
        return false;

      // ✅ Paid Amount (Correct Logic)
      if (paidamountFilter) {
        const amount =
          p.payment_settlement === "Full" ? p.price : p.part_payment_amount;

        if (!String(amount || "").includes(paidamountFilter)) {
          return false;
        }
      }

      if (
        methodFilter &&
        !p.paymentmethod?.toLowerCase().includes(methodFilter.toLowerCase())
      )
        return false;

      if (
        statusFilter &&
        !p.payment_status?.toLowerCase().includes(statusFilter.toLowerCase())
      )
        return false;

      if (
        verificationFilter &&
        !p.payment_reconcile_status
          ?.toLowerCase()
          .includes(verificationFilter.toLowerCase())
      )
        return false;

      // ✅ Date column filters
      if (
        paydateFilter &&
        !moment(p.paydate)
          .format("DD-MMM-YY")
          .toLowerCase()
          .includes(paydateFilter.toLowerCase())
      )
        return false;

      if (
        transactionDateFilter &&
        !moment(p.payment_received_date)
          .format("DD-MMM-YY")
          .toLowerCase()
          .includes(transactionDateFilter.toLowerCase())
      )
        return false;

      return true; // ✅ KEEP THIS
    }).sort((a, b) => {
      const nameA = (a.participant_name || "").toLowerCase();
      const nameB = (b.participant_name || "").toLowerCase();

      return nameA.localeCompare(nameB); // ✅ A → Z
    });
  }
  formatNumber = (value, options = {}) => {
    const num = Number(value);
    return !num || num === 0
      ? "-"
      : num.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
          ...options,
        });
  };
  handleFilterChange = (filterName, e) => {
    const value = e.target.value;

    this.setState(
      prevState => ({
        [filterName]: value,

        dateToActive: filterName === "dateTo" ? true : prevState.dateToActive,
      }),
      this.checkFiltersApplied
    );
  };
  filterData = () => {
    const {
      GetPayment,
      nameFilter = "Select",
      idFilter = "Select",
      districtFilter = "Select",
      schemeFilter = "Select",
      schemepriceFilter = "Select",
      amountFilter = "Select",
      discountFilter = "Select",
      TaxFilter = "Select",
      paymentsettlementFilter = "Select",
      paymentreceivedFilter = "Select",
      membershipStatusFilter = "Select",
      paymentMethodFilter = "Select",
      paymentStatusFilter = "Select",
      reconcileStatusFilter = "Select",
      paidamountFilter = "Select",
      remainingAmountFilter = "Select",
      finalpayableFilter = "Select",
      dateFilter = "",
      dateFrom,
      dateTo,
      dateToActive, // Include activation flag
    } = this.state;

    // Return empty array if no filters are applied
    const filters = [
      nameFilter,
      idFilter,
      districtFilter,
      schemeFilter,
      schemepriceFilter,
      amountFilter,
      discountFilter,
      TaxFilter,
      paymentsettlementFilter,
      paymentMethodFilter,
      paymentStatusFilter,
      reconcileStatusFilter,
      paidamountFilter,
      remainingAmountFilter,
      finalpayableFilter,
      dateFilter,
      paymentreceivedFilter,
      membershipStatusFilter,
      dateFrom,
      dateToActive ? dateTo : "", // Only use dateTo if active
    ];
    const isActive = val =>
      val !== undefined &&
      val !== null &&
      val !== "" &&
      val !== "All" &&
      val !== "Select";
    const isAnyFilterApplied = filters.some(f => f && f !== "Select");

    // 🚫 PAGE LOAD → show nothing
    if (!isAnyFilterApplied) return [];

    return GetPayment.filter(entry => {
      if (
        this.isValidFilter(nameFilter) &&
        !entry.participant_name
          ?.toLowerCase()
          .includes(nameFilter.toLowerCase())
      )
        return false;

      // ✅ ID
      if (
        this.isValidFilter(idFilter) &&
        !entry.id?.toString().includes(idFilter)
      )
        return false;

      // ✅ District
      if (
        this.isValidFilter(districtFilter) &&
        !entry.district?.toLowerCase().includes(districtFilter.toLowerCase())
      )
        return false;

      // ✅ Payment Status (EXACT match)
      if (
        this.isValidFilter(paymentStatusFilter) &&
        entry.payment_status !== paymentStatusFilter
      )
        return false;

      // ✅ Payment Settlement (Full / Part — exact)
      if (
        this.isValidFilter(paymentsettlementFilter) &&
        entry.payment_settlement !== paymentsettlementFilter
      )
        return false;

      // ✅ Reconcile Status
      if (this.isValidFilter(reconcileStatusFilter)) {
        const status = entry.payment_reconcile_status;
        const normalizedStatus =
          status === true || status === 1
            ? "Verified"
            : status === false || status === 0
            ? "Non-Verified"
            : status;

        if (normalizedStatus !== reconcileStatusFilter) return false;
      }
      // ✅ Scheme filter (CORRECT)
      if (isActive(schemeFilter)) {
        const schemeNames = (entry.schemes || []).map(s => s.scheme_name);

        if (!schemeNames.includes(schemeFilter)) {
          return false;
        }
      }

      // ✅ Received By
      if (
        this.isValidFilter(paymentreceivedFilter) &&
        !entry.receivedby
          ?.toLowerCase()
          .includes(paymentreceivedFilter.toLowerCase())
      )
        return false;

      // ✅ Date filters
      if (dateFrom && new Date(entry.paydate) < new Date(dateFrom))
        return false;

      if (dateToActive && new Date(entry.paydate) > new Date(dateTo))
        return false;

      // ================= FIXED NUMERIC FILTERS =================

      // Payable (before discount)
      if (
        this.isValidFilter(schemepriceFilter) &&
        !String(entry.priceBeforeDiscount || "").includes(schemepriceFilter)
      ) {
        return false;
      }

      // Discount Amount
      if (
        this.isValidFilter(discountFilter) &&
        !String(entry.discountAmount || "").includes(discountFilter)
      ) {
        return false;
      }

      // Tax
      if (
        this.isValidFilter(TaxFilter) &&
        !String(entry.taxDeduction || "").includes(TaxFilter)
      ) {
        return false;
      }

      // ✅ Paid Amount (MATCHES UI LOGIC)
      if (this.isValidFilter(paidamountFilter)) {
        const paidAmount =
          entry.payment_settlement === "Full"
            ? entry.price
            : entry.part_payment_amount;

        if (!String(paidAmount || "").includes(paidamountFilter)) {
          return false;
        }
      }

      // Final Payable (CALCULATED SAME AS UI)
      const price = parseFloat(entry.priceBeforeDiscount) || 0;
      const discount = parseFloat(entry.discountAmount) || 0;
      const tax = parseFloat(entry.taxDeduction) || 0;

      const finalPayable = price - discount - tax;

      if (
        this.isValidFilter(finalpayableFilter) &&
        !finalPayable.toString().includes(finalpayableFilter)
      ) {
        return false;
      }

      // Remaining Amount (API VALUE — NOT RECALCULATED)
      if (
        this.isValidFilter(remainingAmountFilter) &&
        !String(entry.remaining_amount || "").includes(remainingAmountFilter)
      ) {
        return false;
      }

      return true;
    });
  };
  render() {
    const defaultSorted = [{ dataField: "id", order: "desc" }];
    const columns = [
      {
        dataField: "participant_name",
        text: "Participant Name",
        style: {
          textAlign: "left",
        },
        headerStyle: {
          backgroundColor: "#87ceeb", // 🌤 sky blue for header
          textAlign: "center",
        },
        headerFormatter: column => (
          <div>
            <div>{column.text}</div>
            <input
              type="text"
              placeholder="Filter"
              value={this.state.nameFilter}
              onChange={e => this.setState({ nameFilter: e.target.value })}
              className="form-control"
            />
          </div>
        ),
      },
      {
        dataField: "part_payment_amount",
        text: "Paid Amount",
        sort: true,
        headerStyle: {
          backgroundColor: "#87ceeb", // 🌤 sky blue for header
          textAlign: "center",
        },
        style: {
          textAlign: "right",
        },

        // ✅ Display Logic
        formatter: (cell, row) => {
          if (row.payment_settlement === "Full") {
            return this.formatNumber(row.price);
          }
          return this.formatNumber(cell);
        },

        // ✅ Header Filter
        headerFormatter: column => (
          <div style={{ textAlign: "center" }}>
            <div>{column.text}</div>
            <div style={{ marginTop: "5px" }}>
              <input
                type="text"
                placeholder="Filter"
                value={this.state.paidamountFilter}
                onChange={e => this.handleFilterChange("paidamountFilter", e)}
                className="form-control"
                style={{
                  textAlign: "center",
                  width: "80px",
                  margin: "auto",
                }}
              />
            </div>
          </div>
        ),
      },

      {
        dataField: "paymentmethod",
        text: "Payment Method",
        headerStyle: {
          backgroundColor: "#87ceeb", // 🌤 sky blue for header
          textAlign: "center",
        },
        headerFormatter: column => (
          <div>
            <div>{column.text}</div>
            <input
              type="text"
              placeholder="Filter"
              value={this.state.methodFilter}
              onChange={e => this.setState({ methodFilter: e.target.value })}
              className="form-control"
            />
          </div>
        ),
      },
      {
        dataField: "payment_status",
        text: "Payment Status",
        headerStyle: {
          backgroundColor: "#87ceeb", // 🌤 sky blue for header
          textAlign: "center",
        },
        headerFormatter: column => (
          <div>
            <div>{column.text}</div>
            <input
              type="text"
              placeholder="Filter"
              value={this.state.statusFilter}
              onChange={e => this.setState({ statusFilter: e.target.value })}
              className="form-control"
            />
          </div>
        ),
        formatter: (cell, row) => {
          let color = "";
          if (row.payment_reconcile_status === "Non-Verified") {
            color = "red";
          } else if (row.payment_reconcile_status === "Verified") {
            color = "green";
          }
          return <span style={{ color, fontWeight: "bold" }}>{cell}</span>;
        },
      },
      {
        dataField: "paydate",
        text: "Date of Payment",
        formatter: cell => (cell ? moment(cell).format("DD-MMM-YY") : "—"),
        headerStyle: {
          backgroundColor: "#87ceeb", // 🌤 sky blue for header
          textAlign: "center",
        },
        headerFormatter: column => (
          <div>
            <div>{column.text}</div>
            <input
              type="text"
              placeholder="Filter"
              value={this.state.paydateFilter}
              onChange={e => this.setState({ paydateFilter: e.target.value })}
              className="form-control"
            />
          </div>
        ),
      },
      {
        dataField: "payment_received_date",
        text: "Date of Transaction",
        formatter: cell => (cell ? moment(cell).format("DD-MMM-YY") : "—"),
        headerStyle: {
          backgroundColor: "#87ceeb", // 🌤 sky blue for header
          textAlign: "center",
        },
        headerFormatter: column => (
          <div>
            <div>{column.text}</div>
            <input
              type="text"
              placeholder="Filter"
              value={this.state.transactionDateFilter}
              onChange={e =>
                this.setState({ transactionDateFilter: e.target.value })
              }
              className="form-control"
            />
          </div>
        ),
      },

      {
        dataField: "payment_reconcile_status",
        text: "Verification Status",
        headerStyle: {
          backgroundColor: "#87ceeb", // 🌤 sky blue for header
          textAlign: "center",
        },
        headerFormatter: column => (
          <div>
            <div>{column.text}</div>
            <input
              type="text"
              placeholder="Filter"
              value={this.state.verificationFilter}
              onChange={e =>
                this.setState({ verificationFilter: e.target.value })
              }
              className="form-control"
            />
          </div>
        ),
      },
    ];
    const {
      searchText,
      filterVerification,
      filterPaymentStatus,
      currentPage,
      rowsPerPage,
    } = this.state;
    const filtered = this.getFilteredPayments();
    const totalPages = Math.ceil(filtered.length / rowsPerPage);
    const pageOptions = {
      sizePerPage: 15,
      totalSize: filtered.length,
      custom: true,
    };

    const totalAmount = filtered.reduce((sum, p) => {
      const val = parseFloat(p.price || 0);
      return sum + (isNaN(val) ? 0 : val);
    }, 0);

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Payment Statement</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="Payments" breadcrumbItem="Payment Statement" />

            {/* ── Summary Cards ── */}
            <Row className="mb-3">
              <Col md={3}>
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium mb-1">
                          Total Records
                        </p>
                        <h4 className="mb-0">{filtered.length}</h4>
                      </div>
                      <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                        <span className="avatar-title rounded-circle bg-primary">
                          <i className="bx bx-receipt font-size-24" />
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              {/* <Col md={3}>
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium mb-1">Total Amount (PKR)</p>
                        <h4 className="mb-0">{totalAmount.toLocaleString()}</h4>
                      </div>
                      <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
                        <span className="avatar-title rounded-circle bg-success">
                          <i className="bx bx-money font-size-24" />
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col> */}
              <Col md={3}>
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium mb-1">Verified</p>
                        <h4 className="mb-0">
                          {
                            filtered.filter(
                              p => p.payment_reconcile_status === "Verified"
                            ).length
                          }
                        </h4>
                      </div>
                      <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
                        <span className="avatar-title rounded-circle bg-success">
                          <i className="bx bx-check-circle font-size-24" />
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md={3}>
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium mb-1">
                          Non-Verified
                        </p>
                        <h4 className="mb-0">
                          {
                            filtered.filter(
                              p => p.payment_reconcile_status === "Non-Verified"
                            ).length
                          }
                        </h4>
                      </div>
                      <div className="avatar-sm rounded-circle bg-warning align-self-center mini-stat-icon">
                        <span className="avatar-title rounded-circle bg-warning">
                          <i className="bx bx-time font-size-24" />
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            {/* ── Filters ── */}
            <Card className="mb-3">
              <CardBody>
                <Row className="align-items-end g-2">
                  <Col md={4}>
                    <Label className="form-label">All Participant</Label>
                    <Input
                      type="select"
                      value={searchText}
                      onChange={e =>
                        this.setState({
                          searchText: e.target.value,
                          currentPage: 1,
                        })
                      }
                    >
                      <option value="">All Participants</option>

                      {[
                        ...new Set(
                          this.props.GetPayment.map(p => p.participant_name)
                        ),
                      ].map((name, index) => (
                        <option key={index} value={name}>
                          {name}
                        </option>
                      ))}
                    </Input>
                  </Col>

                  <Col md={4}>
                    <Label className="form-label">Verification Status</Label>
                    <Input
                      type="select"
                      value={filterVerification}
                      onChange={e =>
                        this.setState({
                          filterVerification: e.target.value,
                          currentPage: 1,
                        })
                      }
                    >
                      <option value="All">All</option>
                      <option value="Verified">Verified</option>
                      <option value="Non-Verified">Non-Verified</option>
                    </Input>
                  </Col>
                  <Col md={4}>
                    <Label className="form-label">Payment Status</Label>
                    <Input
                      type="select"
                      value={filterPaymentStatus}
                      onChange={e =>
                        this.setState({
                          filterPaymentStatus: e.target.value,
                          currentPage: 1,
                        })
                      }
                    >
                      <option value="All">All</option>

                      {[
                        ...new Set(
                          this.props.GetPayment.map(
                            p => p.payment_status || p.payment_status
                          )
                        ),
                      ]
                        .filter(Boolean)
                        .map((status, index) => (
                          <option key={index} value={status}>
                            {status}
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={4}>
                    <Label>Payment Date</Label>
                    <Input
                      type="date"
                      value={this.state.dateFrom}
                      onChange={e =>
                        this.setState({
                          dateFrom: e.target.value,
                          currentPage: 1,
                        })
                      }
                    />
                  </Col>

                  <Col md={4}>
                    <Label>Date To</Label>
                    <Input
                      type="date"
                      value={this.state.dateTo}
                      onChange={e =>
                        this.setState({
                          dateTo: e.target.value,
                          dateToActive: true,
                          currentPage: 1,
                        })
                      }
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* ── Table ── */}
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    data={filtered}
                    columns={columns}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        data={filtered}
                        columns={columns}
                      >
                        {toolkitprops => (
                          <>
                            <BootstrapTable
                              key={this.state.tableKey} // ✅ This is critical!
                              {...toolkitprops.baseProps}
                              {...paginationTableProps}
                              defaultSorted={defaultSorted}
                              classes={"table align-middle"}
                              bordered={false}
                              striped={false}
                              headerWrapperClasses={"table-light"}
                              responsive
                              ref={this.node}
                              filter={filterFactory()} // Ensure filterFactory is applied correctly
                            />

                            <Row>
                              <Col className="pagination pagination-rounded justify-content-end">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </div>
              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

PaymentStatement.propTypes = {
  match: PropTypes.object,
  payments: PropTypes.array,
  onGetParticipantPayments: PropTypes.func,
  GetPayment: PropTypes.array,
};

const mapStateToProps = state => {
  console.log("Redux Full State:", state);
  console.log("AddPayment Slice:", state.AddPayment);
  console.log("GetPayment:", state.AddPayment?.GetPayment);
  console.log("PaymentSchemeList:", state.PaymentScheme?.PaymentSchemeList);

  return {
    GetPayment: state.AddPayment?.GetPayment ?? [],
    PaymentSchemeList: state.PaymentScheme?.PaymentSchemeList || [],
  };
};
const mapDispatchToProps = dispatch => ({
  // ✅ Uncomment and import your actual action
  onGetParticipantPayments: filters => dispatch(getParticipantPayment(filters)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PaymentStatement));
